import { Injectable } from '@angular/core';
import {Type} from "../model/Type";
import {Http, Response} from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { Headers, RequestOptions } from '@angular/http';


@Injectable()
export class GeocodingService {

    geocodingUrl = "https://maps.google.com/maps/controllers/geocode/json?key=AIzaSyBYSUEyeSuHtpxYdn7GU56YGT04IrTK3BE&address=";

    constructor(private http: Http) {}

    queryResults;

    getLocation(address:string): Promise<any> {
        return this.http.get(this.geocodingUrl + "France, " + address)
            .toPromise()
            .then(response => response.json().results)
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);

    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/geocoding.service.ts